export default {
    name: 'settingsservice',
    dependencies: ['xhrservice'],
    callable(xhr) {
        function updateNotificationSetting(type, channel, enabled) {
            return xhr.request({
                url: '/settings/notification.json',
                method: 'post',
                data: {
                    type,
                    channel,
                    enabled,
                },
            });
        }

        function updateUserPreference(preference, enabled) {
            return xhr.request({
                url: '/settings/user.json',
                method: 'post',
                data: {
                    preference,
                    enabled,
                },
            });
        }

        function updateFavoritesPush(enabled) {
            return xhr.request({
                url: '/settings/favoritePush.json',
                method: 'post',
                data: {
                    enabled,
                },
            });
        }

        return {
            updateNotificationSetting,
            updateUserPreference,
            updateFavoritesPush,
        };
    },
};



// WEBPACK FOOTER //
// ./services/settingsservice.js